import { render, staticRenderFns } from "./icon-editor.vue?vue&type=template&id=4b90cd5a&scoped=true&"
import script from "./icon-editor.vue?vue&type=script&lang=js&"
export * from "./icon-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b90cd5a",
  null
  
)

export default component.exports